import { render, staticRenderFns } from "./DeleteDefaultContactModal.vue?vue&type=template&id=08d43e39&scoped=true"
import script from "./DeleteDefaultContactModal.vue?vue&type=script&lang=js"
export * from "./DeleteDefaultContactModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteDefaultContactModal.vue?vue&type=style&index=0&id=08d43e39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d43e39",
  null
  
)

export default component.exports